/**
 * @file: 物理移动后，需要更新的组件列表
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';

function physicsUpdateList(moveTask: MoveTask): CubeId[] {
    let result: Set<CubeId> = new Set();

    findShelf(result, moveTask);
    findLayerInShelf(result, moveTask);
    findStageLayer(result, moveTask);
    findStageCube(result, moveTask);

    return Array.from(result);
}

function findShelf(list: Set<CubeId>, moveTask: MoveTask): void {
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        let moveTarget: CubeId = physicsTask.from.moveTarget;

        if (!CubeTree.isPartition(moveTarget)) {
            return;
        }

        if (!CubeTree.isInShelf(moveTarget)) {
            return;
        }

        let itsShelf: CubeId = CubeTree.findCubeShelf(moveTarget);

        list.add(itsShelf);
    });
}

function findLayerInShelf(list: Set<CubeId>, moveTask: MoveTask): void {
    // 货架中的商品、文本框、隔板
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        let moveTarget: CubeId = physicsTask.from.moveTarget;

        if (!CubeTree.isInLayer(moveTarget)) {
            return;
        }

        let itsLayer: CubeId = CubeTree.findCubeLayer(moveTarget);

        if (!CubeTree.isInShelf(itsLayer)) {
            return;
        }

        let itsShelf: CubeId = CubeTree.findCubeShelf(moveTarget);

        if (list.has(itsShelf)) {
            return;
        }

        list.add(itsLayer);
    });
}

function findStageLayer(list: Set<CubeId>, moveTask: MoveTask): void {
    // 画布中的层板内组件
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        let moveTarget: CubeId = physicsTask.from.moveTarget;

        if (!CubeTree.isInLayer(moveTarget)) {
            return;
        }

        let itsLayer: CubeId = CubeTree.findCubeLayer(moveTarget);

        if (!CubeTree.isInStage(itsLayer)) {
            return;
        }

        list.add(itsLayer);
    });
}

function findStageCube(list: Set<CubeId>, moveTask: MoveTask): void {
    // 画布中的组件
    moveTask.physics.forEach((physicsTask: PhysicsMoveTask): void => {
        let moveTarget: CubeId = physicsTask.from.moveTarget;

        if (!CubeTree.isInStage(moveTarget)) {
            return;
        }

        list.add(moveTarget);
    });
}

export {
    physicsUpdateList
};
